module.exports = __webpack_public_path__ + "static/img/PF.45af6ca7.svg";